document.addEventListener('DOMContentLoaded', () => {

    if(document.getElementById('case-study-select')) {
        const select = document.getElementById('case-study-select');

        select.addEventListener('change', (e) => {
            console.log(e.target.value);
            window.location.href = `${window.location.origin}${e.target.value}`;
        });
    };

    if(document.getElementById('load-more')) {
        const load = document.getElementById('load-more');
        const more = document.getElementById('more');

        load.addEventListener('click', (e) => {
            console.log('clicking');
            load.classList.add('case-study__hide');
            more.classList.remove('case-study__hide');
        });
    };

});


// WEBPACK FOOTER //
// ./source/js/case-studies.js